/* Sketchfoxx · nhãn "Free US ship" trên thẻ hồ sơ (sfx-folder) khi giá >= $40 (ngưỡng free US shipping).
   Không sửa snippet sfx-critter-card.liquid: chỉ gắn thêm 1 span vào dòng giá sau khi trang vẽ xong. */
(function () {
  var MIN = 40;
  function mark(root) {
    (root || document).querySelectorAll('.sfx-folder__price:not([data-ship])').forEach(function (el) {
      el.setAttribute('data-ship', '1');
      var m = (el.textContent || '').match(/\$\s?(\d+(?:\.\d+)?)/); if (!m) return;
      if (parseFloat(m[1]) >= MIN) { var s = document.createElement('span'); s.className = 'sfx-folder__ship'; s.textContent = 'Free US ship'; el.appendChild(s); }
    });
  }
  function go() { mark(); new MutationObserver(function () { mark(); }).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
